import { api } from "api/apiService";

/**
 * Завантажує повний список магазинів.
 * @returns {Promise<Array>} Проміс, що повертає масив з об'єктами магазинів.
 */
export const fetchShops = () => {
  return api.get("/shops");
};

/**
 * Оновлює дані для конкретного магазину.
 * @param {number|string} shopId - ID магазину, якого потрібно оновити.
 * @param {object} data - Об'єкт з полями для оновлення (напр., { trap_sku: "PRO-", token: "new_token_string" }).
 * @returns {Promise<object>} Проміс, що повертає відповідь від сервера.
 */
export const updateShop = (shopId, data) => {
  return api.put(`/shops/${shopId}`, data);
};
